import { render, staticRenderFns } from "./XBtn.vue?vue&type=template&id=1c458a16"
import script from "./XBtn.vue?vue&type=script&lang=js"
export * from "./XBtn.vue?vue&type=script&lang=js"
import style0 from "./XBtn.vue?vue&type=style&index=0&id=1c458a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports